import React, {useEffect, useRef} from 'react';

import EmailInput from './email_input';
import Input from 'react-phone-number-input/input';

// Caps physical entry at a complete AU mobile: "0412 345 678" = 12 chars.
// react-phone-number-input/input forwards unknown props to the underlying
// <input/>, so this becomes the standard HTML maxLength the browser enforces.
const AU_MOBILE_MAX_LENGTH = 12;

interface ContactMethodInputProps {
    contactMethod: 'phone' | 'email';
    onContactMethodChange: (method: 'phone' | 'email') => void;
    phoneNumber: string;
    onPhoneNumberChange: (value: string) => void;
    emailAddress: string;
    onEmailAddressChange: (value: string) => void;
    confirmPhoneNumber?: string;
    onConfirmPhoneNumberChange?: (value: string) => void;
    confirmEmailAddress?: string;
    onConfirmEmailAddressChange?: (value: string) => void;
}

function ContactMethodInput({
    contactMethod,
    onContactMethodChange,
    phoneNumber,
    onPhoneNumberChange,
    emailAddress,
    onEmailAddressChange,
    confirmPhoneNumber,
    onConfirmPhoneNumberChange,
    confirmEmailAddress,
    onConfirmEmailAddressChange,
}: ContactMethodInputProps) {
    const phoneRef = useRef<HTMLInputElement>(null);
    const emailRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (contactMethod === 'phone') {
            phoneRef.current?.focus();
        } else {
            emailRef.current?.focus();
        }
    }, [contactMethod]);

    return (
        <>
            <div className="btn-group w-100 mb-3" role="group" aria-label="Contact method">
                <button
                    type="button"
                    className={`btn ${contactMethod === 'phone' ? 'btn-dark' : 'btn-outline-dark'}`}
                    onClick={() => onContactMethodChange('phone')}
                >
                    Phone
                </button>
                <button
                    type="button"
                    className={`btn ${contactMethod === 'email' ? 'btn-dark' : 'btn-outline-dark'}`}
                    onClick={() => onContactMethodChange('email')}
                >
                    Email
                </button>
            </div>
            {contactMethod === 'phone' ? (
                <>
                    <div className="form-floating mb-4">
                        <Input
                            ref={phoneRef}
                            id="floatingInput"
                            className="form-control border-0 border-bottom phoneInput"
                            international
                            country="AU"
                            maxLength={AU_MOBILE_MAX_LENGTH}
                            value={phoneNumber}
                            onChange={(value: any) => onPhoneNumberChange(String(value || ""))}
                        />
                        <label htmlFor="floatingInput" className={"textSecondary"}>Mobile Number</label>
                        <span className="countryCode textSecondary">+61</span>
                        <small className="text-muted">+61 04XX XXX XXX</small>
                    </div>
                    {onConfirmPhoneNumberChange !== undefined && (
                        <div className="form-floating mb-4">
                            <Input
                                id="confirmPhoneInput"
                                className="form-control border-0 border-bottom phoneInput"
                                international
                                country="AU"
                                maxLength={AU_MOBILE_MAX_LENGTH}
                                value={confirmPhoneNumber || ""}
                                onChange={(value: any) => onConfirmPhoneNumberChange(String(value || ""))}
                            />
                            <label htmlFor="confirmPhoneInput" className={"textSecondary"}>Confirm Mobile Number</label>
                            <span className="countryCode textSecondary">+61</span>
                        </div>
                    )}
                </>
            ) : (
                <>
                    <div className="form-floating mb-4">
                        <EmailInput
                            ref={emailRef}
                            value={emailAddress}
                            onChange={onEmailAddressChange}
                            className="form-control border-0 border-bottom"
                            placeholder=" "
                        />
                        <label htmlFor="emailInput" className={"textSecondary"} style={{opacity: '.65', transform: 'scale(.85) translateY(-.5rem) translateX(.15rem)'}}>Email address</label>
                    </div>
                    {onConfirmEmailAddressChange !== undefined && (
                        <div className="form-floating mb-4">
                            <EmailInput
                                id="confirmEmailInput"
                                value={confirmEmailAddress || ""}
                                onChange={onConfirmEmailAddressChange}
                                className="form-control border-0 border-bottom"
                                placeholder=" "
                            />
                            <label htmlFor="confirmEmailInput" className={"textSecondary"} style={{opacity: '.65', transform: 'scale(.85) translateY(-.5rem) translateX(.15rem)'}}>Confirm email address</label>
                        </div>
                    )}
                </>
            )}
        </>
    );
}

export default ContactMethodInput;
